window.addEventListener("scroll", () => {
    const module1 = document.querySelector(".Best-Sellers");
    const module2 = document.querySelector(".Product-News");
    const module3 = document.querySelector(".BFCM-2023-email");
    const module4 = document.querySelector(".home-reviews-swiper");

     const scrollPosition = window.scrollY;

     const module2Position = module2.offsetTop - 500;
     const module3Position = module3.offsetTop - 500
     const module4Position = module4.offsetTop - 500;


     if (scrollPosition >= module2Position && scrollPosition < module3Position) {
      module1.classList.add("module-color");
      module2.classList.add("module-color");
      module3.classList.add("module-color");
      module4.classList.add("module-color");
    } else if (scrollPosition >= module3Position && scrollPosition < module4Position) {
      module1.classList.remove("module-color");
      module2.classList.remove("module-color");
      module3.classList.remove("module-color");
      module4.classList.remove("module-color");
    } else if (scrollPosition >= module4Position) {
        module1.classList.add("module-color");
        module2.classList.add("module-color");
        module3.classList.add("module-color");
        module4.classList.add("module-color");
    } else {
        module1.classList.remove("module-color");
      module2.classList.remove("module-color");
      module3.classList.remove("module-color");
      module4.classList.remove("module-color");
    }


});


const dicountList = document.querySelectorAll('.product-disount-message')

dicountList.forEach(function(item) {
  var productElement = item.querySelector('.product-discount-news');

  if (!productElement) {
    var newProductDiv = document.createElement('div');
    newProductDiv.className = 'product-discount-news';
    item.appendChild(newProductDiv);
  }
});